const NotFound = () => {
    return (
        <div>
            <h1 className='text-5xl text-lime-800 my-5'>The Page is not available you are looking for!!!</h1>
            <h1 className='text-4xl text-lime-800 mb-5'>404</h1>
            <img className='mx-auto' src="https://cdn.mos.cms.futurecdn.net/PuXipAW3AXUzUJ4uYyxPKC-1200-80.jpg" alt="" />
        </div>
    );
};

export default NotFound;
